import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider, initI18n } from '@wix/wix-i18n-config';
import App from './components/App';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { getUserData, getThanks } from './services/window-utils';
import { WixDesignSystemProvider } from '@wix/design-system';
import '@wix/design-system/styles.global.css';

const experiments = window.__EXPERIMENTS__;

const i18n = initI18n({
  locale: window.__LOCALE__,
  messages: window.__MESSAGES__,
});

const isOnThanks = getThanks() === 'true';
const userData = getUserData();

ReactDOM.render(
  <Suspense fallback="...loading">
    <WixDesignSystemProvider>
      <I18nextProvider i18n={i18n}>
        <ExperimentsProvider options={{ experiments }}>
          <App isOnThanks={isOnThanks} userData={userData} />
        </ExperimentsProvider>
      </I18nextProvider>
    </WixDesignSystemProvider>
  </Suspense>,
  document.getElementById('root'),
);
